export default __webpack_public_path__ + "static/media/good.3ac2f6b1.svg";